import { prepareWriteContract, writeContract , waitForTransaction } from '@wagmi/core'
import Contracts from '../config/contract.json'
import PresaleABI from '../config/abi/Presale.json'
import BigNumber from 'bignumber.js'


export async function BuyToken(amount,presaleAddr) {
  
     
    try{ 
        
       const config = await prepareWriteContract({
       address: presaleAddr,
       abi: PresaleABI,
       functionName: 'buyToken',
       value: new BigNumber(amount).times(new BigNumber(10).pow(18)).toString()
     })


      const { hash } = await writeContract(config)

      const waitTx = waitForTransaction({hash:hash});

      return waitTx;

   }catch(e){
     return {status:"error", message:e};
   }
   
}

export async function ClaimToken(presaleAddr) {
     
  try{ 
      
     const config = await prepareWriteContract({
     address: presaleAddr,
     abi: PresaleABI,
     functionName: 'claimToken'
   })


    const { hash } = await writeContract(config)

    const waitTx = waitForTransaction({hash:hash});

    return waitTx;

 }catch(e){
   return {status:"error", message:e};
 }
 
}